import * as yup from "yup";
import { useTranslation } from "react-i18next";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../shared/components/input/FormInput";

const CreateClientCampaignForm = ({ onSubmitHandler }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    code: yup
      .string()
      .required(
        t("clients.detail.tabs.campaigns.createForm.fields.code.required"),
      ),
    name: yup
      .string()
      .required(
        t("clients.detail.tabs.campaigns.createForm.fields.name.required"),
      ),
  });

  const defaultValues = {
    code: "",
    name: "",
    description: "",
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <FormInput
        name="code"
        label={t("clients.detail.tabs.campaigns.createForm.fields.code.label")}
        required
      />
      <FormInput
        name="name"
        label={t("clients.detail.tabs.campaigns.createForm.fields.name.label")}
        required
      />
      <FormInput
        name="description"
        label={t(
          "clients.detail.tabs.campaigns.createForm.fields.description.label",
        )}
      />
    </BaseForm>
  );
};

export default CreateClientCampaignForm;
